import { AxiosInstance, AxiosRequestConfig, CancelToken } from 'axios';
import {
  ITextLinkToDownloadAppRequestBody,
  PageFilter,
  RecentlySearchedTermsResponse,
  SearchRequestBody,
} from './types';

export const sendText = async (axios: AxiosInstance, request: ITextLinkToDownloadAppRequestBody) => {
  request.phoneNumber = request.phoneNumber.indexOf('+') === 0 ? request.phoneNumber : `+1${request.phoneNumber}`;
  const res = await axios.post('/waitingList/textLinkToDownloadApp', request);
  return res?.data;
};

export const searchProductsRest = async (
  axios: AxiosInstance,
  body: SearchRequestBody,
  page: PageFilter,
  facets?: {
    computeFacets: boolean;
    facetFieldNames?: string[];
  },
  cancelToken?: CancelToken,
) => {
  const res = await axios.post(
    '/product/search',
    { body, page, facets },
    {
      cancelToken,
    },
  );
  return res?.data;
};

export const getEntityForLandingPage = async ({
  axiosEdgeCached,
  entityId,
  entityType,
}: {
  axiosEdgeCached: AxiosInstance;
  entityId: string | number;
  entityType: 'brand' | 'product' | 'category' | 'subCategory';
}) => {
  return axiosEdgeCached.get(`/cms/landing/${entityType}/${entityId}/entity`);
};

export const getRecentlySearchedTerms = async (axios: AxiosInstance, headers: AxiosRequestConfig['headers']) => {
  return axios.get<RecentlySearchedTermsResponse>('/recentlyViewed/getSearches', { headers });
};
